import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	HostBinding,
	Output,
	ViewEncapsulation,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { IauiVerificationAction } from "@obg/ngx.common";
import { CoreState } from "@obg/ngx.core";

import { IauiPaymentTypePayload } from "./iaui-verification.model";

@Component({
	selector: "obg-m-iaui-verification-step",
	templateUrl: "./iaui-verification-step.container.html",
	styleUrls: ["./iaui-verification-step.container.scss"],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IauiVerificationStepContainer {
	@HostBinding("class.obg-m-iaui-verification-step") hostCssClass = true;
	@Output() nextStep = new EventEmitter();
	title = "customer-verification.modal.title";

	constructor(
		private store: Store<CoreState>,
		private iauiVerificationAction: IauiVerificationAction
	) {}

	onDone({ paymentType }: IauiPaymentTypePayload) {
		this.store.dispatch(this.iauiVerificationAction.closeModal(paymentType));
		this.nextStep.emit();
	}
}
